import { styled } from '@mui/material';

const Form = styled('form')`
  width: 100%;
  height: 400px;
  padding: 20px;
`;

export default Form;
